export const messages = {
  en: {
    resourceOutManage: {
      orderId: 'Order ID',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      itemCode: 'Item Code',
      itemStock: 'Stock',
      applyQuantity: 'Apply Quantity',
      issueQuantity: 'Issue Quantity',
      issueQuantityPlaceholder: 'Required, please enter issue quantity',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      submit: 'Submit',
      quantityRequired: 'Please enter issue quantity',
      insufficientStock: 'Insufficient stock',
      submitSuccess: 'Submit success',
      submitError: 'Submit failed',
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    resourceOutManage: {
      orderId: '单号',
      itemType: '物品类型',
      itemName: '物品名称',
      itemSpec: '物品规格',
      itemCode: '物品编码',
      itemStock: '物品库存',
      applyQuantity: '申请数量',
      issueQuantity: '发放数量',
      issueQuantityPlaceholder: '必填，请填写发放数量',
      remark: '备注',
      remarkPlaceholder: '可填，请填写备注',
      submit: '提交',
      quantityRequired: '请填写发放数量',
      insufficientStock: '库存不足',
      submitSuccess: '提交成功',
      submitError: '提交失败',
      fetchError: '获取数据失败'
    }
  },
  'zh-TW': {
    resourceOutManage: {
      orderId: '單號',
      itemType: '物品類型',
      itemName: '物品名稱',
      itemSpec: '物品規格',
      itemCode: '物品編碼',
      itemStock: '物品庫存',
      applyQuantity: '申請數量',
      issueQuantity: '發放數量',
      issueQuantityPlaceholder: '必填，請填寫發放數量',
      remark: '備註',
      remarkPlaceholder: '可填，請填寫備註',
      submit: '提交',
      quantityRequired: '請填寫發放數量',
      insufficientStock: '庫存不足',
      submitSuccess: '提交成功',
      submitError: '提交失敗',
      fetchError: '獲取數據失敗'
    }
  }
}